import {
    arrayOf,
    bool,
    string,
    shape,
    objectOf,
    oneOfType,
    number,
    object,
} from 'prop-types';
import wishlistShape from 'shapes/wishlistShape';

export default shape({
    location: shape({
        pathname: string,
    }),
    wishlist: wishlistShape,
    user: shape({
        acount: object,
    }),
    is_sales_period: bool,
    platform: string,
    flags: objectOf(oneOfType([string, number, bool, arrayOf(string)])),
});
